<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label="v" class="page" id="pv" role="doc-pagebreak"></span>Contents</h1>
</header>
<p class="tocfm"><a class="xref" href="#/wsutvmouterlimits0007#acknow" id="racknow">Acknowledgments</a></p>
<p class="tocf"><a class="xref" href="#/wsutvmouterlimits0008#intro" id="rintro">Introduction</a></p>
<p class="toc"><a class="xref" href="#/wsutvmouterlimits0009#ch01" id="rch01">1. Highbrow Meets Lowbrow</a></p>
<p class="toc"><a class="xref" href="#/wsutvmouterlimits0010#ch02" id="rch02">2. Televisuality in <i>The Outer Limits</i>: Noir Science and Gothic Science Fiction</a></p>
<p class="toc"><a class="xref" href="#/wsutvmouterlimits0011#ch03" id="rch03">3. Behind the New Frontier</a></p>
<p class="toc"><a class="xref" href="#/wsutvmouterlimits0012#ch04" id="rch04">4. <i>The Outer Limits</i> as Creative Adaptation</a></p>
<p class="toc"><a class="xref" href="#/wsutvmouterlimits0013#ch05" id="rch05">5. Beyond <i>The Outer Limits</i></a></p>
<p class="tocbmf"><a class="xref" href="#/wsutvmouterlimits0014#refs" id="rrefs">References</a></p>
<p class="tocbm"><a class="xref" href="#/wsutvmouterlimits0015#index" id="rindex">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// wsu-tvmouterlimits-0006.vue?8a83c378